import { config } from "../config";
export var setRevision = function(appName) {
    try {
        localStorage.setItem("vch.app_name", appName);
        localStorage.setItem("vch.app_revision", config.revision);
        return true;
    } catch (e) {
        return false;
    }
};
export var getRevision = function() {
    var appRevision = config.revision;
    try {
        var _localStorage_getItem;
        var appName = (_localStorage_getItem = localStorage.getItem("vch.app_name")) !== null && _localStorage_getItem !== void 0 ? _localStorage_getItem : "unknown";
        return {
            appName: appName,
            appRevision: appRevision
        };
    } catch (e) {
        return {
            appName: "unknown",
            appRevision: appRevision
        };
    }
};

//# sourceMappingURL=revision.js.map